/**
 * Returns true ONLY IF:
 * - user is super admin OR
 * - user has ALL required permissions
 *
 * @param {string[]} requiredPermissions
 */
export const hasAllPermissions = (requiredPermissions = []) => (state) => {
  const { isSuperAdmin, permissions } = state.auth;

  if (isSuperAdmin === true) {
    return true;
  }

  if (!Array.isArray(requiredPermissions) || requiredPermissions.length === 0) {
    return false;
  }

  return requiredPermissions.every(
    (permission) => permissions?.[permission] === true
  );
};
